if (!window.fetch || !window.Promise) {
  // sanity check for IE11 and other old browsers
  throw new Error(
    "Reward plugin: Unsupported browser!\nPlease use a modern browser like Chrome, Firefox, Safari, or Edge.",
  );
}

import { identity, loadToken, reloadUserState } from "./logic/config";
import { FloatingButton, FloatingWidget } from "./components";
import { queue, RewardVarName } from "./init";
import { loadReferralCode } from "./logic/tracking";

const options: Record<string, unknown> = {};
let isLoading = true;

const main = () => {
  try {
    loadReferralCode();
  } catch {
    // ignore
  }

  window[RewardVarName] = rewardPlugin;

  for (const value of queue) {
    rewardPlugin(...value);
  }

  setTimeout(() => {
    reload();
    isLoading = false;
  }, 0);
};

const rewardPlugin = (arg1?: unknown) => {
  if (!arg1) return;

  if (typeof arg1 === "object") {
    Object.assign(options, arg1);
  }

  if (!isLoading) {
    reload();
  }
};

const reload = () => {
  if (!identity && typeof options.userToken === "string") {
    void loadOptions(options as { userToken: string });
  }
};

const loadOptions = async (options: { userToken: string }) => {
  const state = await loadToken(options);
  if (!state) return;

  const toggle = new FloatingButton({
    visible: state.floatingButton.visible,
    color: state.theme.mainColor,
    badge: state.badge.unreadCount,
    variant: state.floatingButton.variant ?? "tab",
    placement: state.floatingButton.placement ?? "bottom-right",
    positionPixels: state.floatingButton.positionPixels ?? 70,
  });

  const widget = new FloatingWidget({
    token: state.urlToken,
    onClose: () => {
      toggle.update({ visible: true, badge: 0 });
      widget.update({ open: false });

      void reloadUserState().then((state) => {
        if (!state) {
          toggle.update({ visible: false });
          widget.update({ open: false });
          return;
        }

        toggle.update({
          badge: state.badge.unreadCount,
        });
      });
    },
  });

  toggle.onClick(() => {
    toggle.update({ visible: false });
    widget.update({ open: true });
  });
};

// make sure main is running is last
main();
